import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import getCoupons from "../../../api/coupon/getCoupons";
import { useTheme } from "@mui/material/styles";
import CouponDialog from "../../../component/management/CouponDialog";
import {
  DataGrid,
  zhTW,
  GridToolbarContainer,
  GridActionsCellItem,
} from "@mui/x-data-grid";

export default function CouponPage() {
  const [selectedCoupon, setSelectedCoupon] = useState({});
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const [coupons, setCoupons] = useState([]);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const data = await getCoupons();


        setCoupons(data.Coupons);
      } catch (err) {
        setError(err.message);
      }
    };

    if (coupons) {
      fetchCoupons();
    }
  }, []);
  function EditToolbar() {
    const handleClick = () => {
      setIsAdd(true);
      setOpen(true);
    };

    return (
      <GridToolbarContainer>
        <Button color="info" startIcon={<AddIcon />} onClick={handleClick}>
          新增優惠券
        </Button>
      </GridToolbarContainer>
    );
  }

  const handleEditClick = (id) => () => {
    setIsAdd(false);

    setSelectedCoupon(coupons.find(coupon => coupon.Id === id));
    setOpen(true);
  };

  const columns = [
    {
      field: "操作",
      type: "actions",
      headerName: "操作",
      width: 70,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={handleEditClick(id)}
            color="inherit"
          />,
        ];
      },
    },
    { field: "Id", headerName: "編號", width: 130 },
    { field: "Name", headerName: "名稱", width: 130 },
    { field: "Price", headerName: "折扣金額", width: 130 },
    {
      field: "IsValid",
      headerName: "有效",
      type: "bool",
      width: 110,
    },
  ];

  return (
    <>
      <div style={{ height: 500, width: "100%" }}>
        <DataGrid
          localeText={zhTW.components.MuiDataGrid.defaultProps.localeText}
          rows={coupons||[]}
          columns={columns}
          disableColumnSelector
          disableRowSelectionOnClick
          sx={{ color: theme.palette.text.primary }}
          getRowId={(row) => row.Id}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 5 },
            },
          }}
          slots={{
            toolbar: EditToolbar,
          }}
          slotProps={{
            toolbar: {},
          }}
          pageSizeOptions={[5, 10]}
        />
      </div>
      <CouponDialog
        coupon={selectedCoupon}
        isAdd={isAdd}
        open={open}
        setOpen={setOpen}
      ></CouponDialog>
    </>
  );
}
